/**
 * Tokens visuais da Rede Proto.
 *
 * O app usa a paleta teal (#004D43); a Rede Proto tem identidade roxa própria
 * (#B028FD, do protótipo). Estes tokens ficam isolados na aba para não vazar
 * para o tema global do MUI. Sempre referencie estas constantes — nunca repita
 * o valor hex espalhado pelos componentes.
 */
import { PoleClassification } from '../../../../../api/theHive/redeProto/types';

export const protoColors = {
  purple: '#B028FD',
  purpleDark: '#8A1FCB',
  purpleSoft: 'rgba(176, 40, 253, 0.10)',
  ink: '#0A0A0B',
  surface: '#FFFFFF',
  surfaceSubtle: '#F8F8FA',
  border: '#EAEAEF',
  textPrimary: '#18181B',
  textMuted: '#6B7280',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
} as const;

export const classificationColor: Record<PoleClassification, string> = {
  critical: protoColors.danger,
  attention: protoColors.warning,
  healthy: protoColors.success,
  excellent: protoColors.purple,
};

/** Cor neutra para valores indisponíveis (`null`). */
export const neutralColor = protoColors.textMuted;

/** Acessor seguro: classificação `null` → cor neutra. */
export const classificationColorOf = (
  classification: PoleClassification | null | undefined
): string =>
  classification ? classificationColor[classification] : neutralColor;

/**
 * Cor para um valor em escala 0–100 (SLA, cobertura, aprovação): vermelho →
 * amarelo → verde. Usada nas células de heatmap e barras. `null` → neutro.
 */
export const heatColor = (pct: number | null | undefined): string => {
  if (pct == null) return neutralColor;
  if (pct >= 90) return protoColors.success;
  if (pct >= 70) return '#84CC16';
  if (pct >= 50) return protoColors.warning;
  return protoColors.danger;
};

/** Cor para CSAT na escala 0–5. `null` → neutro. */
export const csatColor = (csat: number | null | undefined): string => {
  if (csat == null) return neutralColor;
  if (csat >= 4.5) return protoColors.success;
  if (csat >= 4.0) return '#84CC16';
  if (csat >= 3.5) return protoColors.warning;
  return protoColors.danger;
};
